import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";

import api from "../../services/AxiosInstance";

// ============================================================
// FETCH SMS GATEWAY
// Templates + Summary + Logs
// ============================================================

export const fetchSmsGatewayThunk =
  createAsyncThunk(
    "smsGateway/fetch",

    async (
      panId,
      { rejectWithValue }
    ) => {
      try {
        const params = {};

        if (Number(panId) > 0) {
          params.pan_id =
            Number(panId);
        }

        const res = await api.get(
          "/api/v1/sms-gateway",
          {
            params,
          }
        );

        if (
          res.data?.success ===
          false
        ) {
          return rejectWithValue(
            res.data?.message ||
              "Failed to load SMS Gateway"
          );
        }

        return (
          res.data?.data ||
          {}
        );
      } catch (error) {
        return rejectWithValue(
          error?.response?.data
            ?.message ||
            error?.message ||
            "Failed to load SMS Gateway"
        );
      }
    }
  );

// ============================================================
// FETCH SMS SETTINGS
// Current selected Panchayath
// ============================================================

export const fetchSmsSettingsThunk =
  createAsyncThunk(
    "smsGateway/fetchSettings",

    async (
      panId,
      { rejectWithValue }
    ) => {
      try {
        const id =
          Number(panId);

        if (!id) {
          return rejectWithValue(
            "Please select one Panchayath"
          );
        }

        const res = await api.get(
          "/api/v1/sms-gateway/settings",
          {
            params: {
              pan_id: id,
            },
          }
        );

        if (
          res.data?.success ===
          false
        ) {
          return rejectWithValue(
            res.data?.message ||
              "Failed to load SMS settings"
          );
        }

        return (
          res.data?.data ||
          {}
        );
      } catch (error) {
        return rejectWithValue(
          error?.response?.data
            ?.message ||
            error?.message ||
            "Failed to load SMS settings"
        );
      }
    }
  );

// ============================================================
// UPDATE SMS SETTINGS
// ============================================================

export const updateSmsSettingsThunk =
  createAsyncThunk(
    "smsGateway/updateSettings",

    async (
      payload,
      { rejectWithValue }
    ) => {
      try {
        const panId =
          Number(
            payload?.pan_id
          );

        if (!panId) {
          return rejectWithValue(
            "Please select one Panchayath"
          );
        }

        const res = await api.put(
          "/api/v1/sms-gateway/settings",
          {
            pan_id:
              panId,

            bill_generation_sms:
              payload
                ?.bill_generation_sms ||
              "no",

            receipt_generation_sms:
              payload
                ?.receipt_generation_sms ||
              "no",

            payment_reminder_sms:
              payload
                ?.payment_reminder_sms ||
              "no",
          }
        );

        if (
          res.data?.success ===
          false
        ) {
          return rejectWithValue(
            res.data?.message ||
              "Failed to update SMS settings"
          );
        }

        return res.data;
      } catch (error) {
        return rejectWithValue(
          error?.response?.data
            ?.message ||
            error?.message ||
            "Failed to update SMS settings"
        );
      }
    }
  );

// ============================================================
// UPDATE GLOBAL TEMPLATE
// ============================================================

export const updateSmsTemplateThunk =
  createAsyncThunk(
    "smsGateway/updateTemplate",

    async (
      {
        id,
        data,
      },
      { rejectWithValue }
    ) => {
      try {
        const res = await api.put(
          `/api/v1/sms-gateway/templates/${id}`,
          data
        );

        if (
          res.data?.success ===
          false
        ) {
          return rejectWithValue(
            res.data?.message ||
              "Failed to update SMS template"
          );
        }

        return res.data;
      } catch (error) {
        return rejectWithValue(
          error?.response?.data
            ?.message ||
            error?.message ||
            "Failed to update SMS template"
        );
      }
    }
  );

// ============================================================
// MANUAL BILL GENERATION SMS
// ============================================================

export const sendBillGenerationSmsThunk =
  createAsyncThunk(
    "smsGateway/sendBillGeneration",

    async (
      payload,
      { rejectWithValue }
    ) => {
      try {
        const res = await api.post(
          "/api/v1/sms-gateway/send/bill-generation",
          payload
        );

        if (
          res.data?.success ===
          false
        ) {
          return rejectWithValue(
            res.data?.message ||
              "Failed to send bill SMS"
          );
        }

        return res.data;
      } catch (error) {
        return rejectWithValue(
          error?.response?.data
            ?.message ||
            error?.message ||
            "Failed to send bill SMS"
        );
      }
    }
  );

// ============================================================
// MANUAL RECEIPT GENERATION SMS
// ============================================================

export const sendReceiptGenerationSmsThunk =
  createAsyncThunk(
    "smsGateway/sendReceiptGeneration",

    async (
      payload,
      { rejectWithValue }
    ) => {
      try {
        const res = await api.post(
          "/api/v1/sms-gateway/send/receipt-generation",
          payload
        );

        if (
          res.data?.success ===
          false
        ) {
          return rejectWithValue(
            res.data?.message ||
              "Failed to send receipt SMS"
          );
        }

        return res.data;
      } catch (error) {
        return rejectWithValue(
          error?.response?.data
            ?.message ||
            error?.message ||
            "Failed to send receipt SMS"
        );
      }
    }
  );

// ============================================================
// MANUAL PAYMENT REMINDER
// ============================================================

export const sendPaymentReminderThunk =
  createAsyncThunk(
    "smsGateway/sendPaymentReminder",

    async (
      payload,
      { rejectWithValue }
    ) => {
      try {
        const res = await api.post(
          "/api/v1/sms-gateway/send/payment-reminder",
          payload
        );

        if (
          res.data?.success ===
          false
        ) {
          return rejectWithValue(
            res.data?.message ||
              "Failed to send payment reminder"
          );
        }

        return res.data;
      } catch (error) {
        return rejectWithValue(
          error?.response?.data
            ?.message ||
            error?.message ||
            "Failed to send payment reminder"
        );
      }
    }
  );

// ============================================================
// SLICE
// ============================================================

const smsGatewaySlice =
  createSlice({
    name:
      "smsGateway",

    initialState: {
      settings: {
        pan_id: 0,

        bill_generation_sms:
          "no",

        receipt_generation_sms:
          "no",

        payment_reminder_sms:
          "no",
      },

      templates: [],

      logs: [],

      summary: {
        total_sms: 0,
        sent_sms: 0,
        failed_sms: 0,
        pending_sms: 0,
      },

      loading: false,

      settingsLoading:
        false,

      savingSettings:
        false,

      saving: false,

      sending: false,

      error: null,

      success: null,
    },

    reducers: {
      clearSmsGatewayMsg:
        (state) => {
          state.error =
            null;

          state.success =
            null;
        },

      resetSmsSettings:
        (state) => {
          state.settings = {
            pan_id: 0,

            bill_generation_sms:
              "no",

            receipt_generation_sms:
              "no",

            payment_reminder_sms:
              "no",
          };
        },
    },

    extraReducers:
      (builder) => {
        builder

          // ==================================================
          // FETCH GATEWAY
          // ==================================================

          .addCase(
            fetchSmsGatewayThunk.pending,
            (state) => {
              state.loading =
                true;

              state.error =
                null;
            }
          )

          .addCase(
            fetchSmsGatewayThunk.fulfilled,
            (
              state,
              action
            ) => {
              state.loading =
                false;

              state.templates =
                action.payload
                  ?.templates ||
                [];

              state.logs =
                action.payload
                  ?.logs ||
                [];

              state.summary = {
                ...state.summary,

                ...(action.payload
                  ?.summary ||
                  {}),
              };
            }
          )

          .addCase(
            fetchSmsGatewayThunk.rejected,
            (
              state,
              action
            ) => {
              state.loading =
                false;

              state.error =
                action.payload ||
                "Failed to load SMS Gateway";
            }
          )

          // ==================================================
          // FETCH SETTINGS
          // ==================================================

          .addCase(
            fetchSmsSettingsThunk.pending,
            (state) => {
              state.settingsLoading =
                true;

              state.error =
                null;
            }
          )

          .addCase(
            fetchSmsSettingsThunk.fulfilled,
            (
              state,
              action
            ) => {
              state.settingsLoading =
                false;

              state.settings = {
                pan_id:
                  Number(
                    action.payload
                      ?.pan_id ||
                      0
                  ),

                bill_generation_sms:
                  action.payload
                    ?.bill_generation_sms ||
                  "no",

                receipt_generation_sms:
                  action.payload
                    ?.receipt_generation_sms ||
                  "no",

                payment_reminder_sms:
                  action.payload
                    ?.payment_reminder_sms ||
                  "no",

                sms_setting_id:
                  action.payload
                    ?.sms_setting_id ||
                  null,

                created_at:
                  action.payload
                    ?.created_at ||
                  null,

                updated_at:
                  action.payload
                    ?.updated_at ||
                  null,
              };
            }
          )

          .addCase(
            fetchSmsSettingsThunk.rejected,
            (
              state,
              action
            ) => {
              state.settingsLoading =
                false;

              state.error =
                action.payload ||
                "Failed to load SMS settings";
            }
          )

          // ==================================================
          // UPDATE SETTINGS
          // ==================================================

          .addCase(
            updateSmsSettingsThunk.pending,
            (state) => {
              state.savingSettings =
                true;

              state.error =
                null;
            }
          )

          .addCase(
            updateSmsSettingsThunk.fulfilled,
            (
              state,
              action
            ) => {
              state.savingSettings =
                false;

              if (
                action.payload
                  ?.data
              ) {
                state.settings = {
                  ...state.settings,

                  ...action.payload
                    .data,
                };
              }

              state.success =
                action.payload
                  ?.message ||
                "SMS settings updated successfully";
            }
          )

          .addCase(
            updateSmsSettingsThunk.rejected,
            (
              state,
              action
            ) => {
              state.savingSettings =
                false;

              state.error =
                action.payload ||
                "Failed to update SMS settings";
            }
          )

          // ==================================================
          // TEMPLATE
          // ==================================================

          .addCase(
            updateSmsTemplateThunk.pending,
            (state) => {
              state.saving =
                true;

              state.error =
                null;
            }
          )

          .addCase(
            updateSmsTemplateThunk.fulfilled,
            (
              state,
              action
            ) => {
              state.saving =
                false;

              state.success =
                action.payload
                  ?.message ||
                "SMS template updated successfully";
            }
          )

          .addCase(
            updateSmsTemplateThunk.rejected,
            (
              state,
              action
            ) => {
              state.saving =
                false;

              state.error =
                action.payload ||
                "Failed to update SMS template";
            }
          )

          // ==================================================
          // BILL SMS
          // ==================================================

          .addCase(
            sendBillGenerationSmsThunk.pending,
            (state) => {
              state.sending =
                true;

              state.error =
                null;
            }
          )

          .addCase(
            sendBillGenerationSmsThunk.fulfilled,
            (
              state,
              action
            ) => {
              state.sending =
                false;

              state.success =
                action.payload
                  ?.message ||
                "Bill SMS queued successfully";
            }
          )

          .addCase(
            sendBillGenerationSmsThunk.rejected,
            (
              state,
              action
            ) => {
              state.sending =
                false;

              state.error =
                action.payload ||
                "Failed to send bill SMS";
            }
          )

          // ==================================================
          // RECEIPT SMS
          // ==================================================

          .addCase(
            sendReceiptGenerationSmsThunk.pending,
            (state) => {
              state.sending =
                true;

              state.error =
                null;
            }
          )

          .addCase(
            sendReceiptGenerationSmsThunk.fulfilled,
            (
              state,
              action
            ) => {
              state.sending =
                false;

              state.success =
                action.payload
                  ?.message ||
                "Receipt SMS queued successfully";
            }
          )

          .addCase(
            sendReceiptGenerationSmsThunk.rejected,
            (
              state,
              action
            ) => {
              state.sending =
                false;

              state.error =
                action.payload ||
                "Failed to send receipt SMS";
            }
          )

          // ==================================================
          // PAYMENT REMINDER
          // ==================================================

          .addCase(
            sendPaymentReminderThunk.pending,
            (state) => {
              state.sending =
                true;

              state.error =
                null;
            }
          )

          .addCase(
            sendPaymentReminderThunk.fulfilled,
            (
              state,
              action
            ) => {
              state.sending =
                false;

              state.success =
                action.payload
                  ?.message ||
                "Payment reminder queued successfully";
            }
          )

          .addCase(
            sendPaymentReminderThunk.rejected,
            (
              state,
              action
            ) => {
              state.sending =
                false;

              state.error =
                action.payload ||
                "Failed to send payment reminder";
            }
          );
      },
  });

export const {
  clearSmsGatewayMsg,
  resetSmsSettings,
} =
  smsGatewaySlice.actions;

export default
smsGatewaySlice.reducer;